export default "__VITE_ASSET__aWJItSg5__"